module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-hum-d31f113312b7683a4d9e391bb77c6f0a.png";